import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormGroup, FormControl, Validators, ValidationErrors } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';

import { ToastrService } from 'ngx-toastr';
import { RecaptchaComponent } from 'ng-recaptcha';

import { MatDialog } from '@angular/material/dialog';

import { DialogLightComponent } from '../../../ui/dialog-light/dialog-light';
import { ModernDatepickerHeaderComponent } from '../../../ui/modern-datepicker-header/modern-datepicker-header.component';

import { CustomerProvider } from '../../../providers/customer/customer';
import { GoalProvider } from '../../../providers/goal/goal';
import { AuthService } from '../../../providers/auth/auth.service';
import { UserProvider } from '../../../providers/user/user';
import { ApiProvider } from '../../../providers/api/api';
import { HelpersProvider } from '../../../providers/helpers/helpers';
import { I18nProvider } from '../../../providers/i18n/i18n';

import { environment } from '../../../environments/environment';
import packageJson from '../../../../package.json';
import { codes } from '../../../providers/helpers/countriesJson_ptBR';
import { ModernSearchSelectOption } from '../../../ui/modern-search-select/modern-search-select.component';
import {
  applyLayoutTheme,
  isModernLayoutTheme,
  LAYOUT_THEMES,
  LAYOUT_THEME_STORAGE_KEY,
  LayoutThemeValue,
  normalizeLayoutTheme,
} from '../../../providers/layout-theme/layout-theme';

@Component({
  selector: 'app-alunos-precad',
  templateUrl: './precad.component.html',
  styleUrls: ['./precad.component.scss']
})
export class AlunosPrecadComponent implements OnDestroy, OnInit {
  readonly layoutThemes = LAYOUT_THEMES;
  readonly precadDatepickerHeader = ModernDatepickerHeaderComponent;
  readonly birthdateMin = new Date(1940, 0, 1);
  readonly birthdateMax = new Date();
  @ViewChild('captchaRef') captchaRef!: RecaptchaComponent;
  public version: string = packageJson.version;
  PAGE: any;
  STRINGS: any;
  ENV: any = environment;
  recaptchaEnabled: boolean = environment.RECAPTCHA_ENABLED !== false;
  captcha: string = null;
  selectedLayoutTheme: LayoutThemeValue = 'modern-dark';
  modernLayoutTheme: boolean = false;

  protected headers: any;
  teacherCode: string = '';

  loading: boolean = false;
  expired: boolean = false;
  showForm: boolean = false;
  done: boolean = false;
  studentGender: string = '';
  userBirthdate: any;
  userGoalId: number;
  goals: any = [];
  teacher: any = [];
  route_id: string = '0';
  codes = codes;
  ddiOptions: ModernSearchSelectOption[] = [];

  studentSelected: boolean = false;
  studentId: number = 0;
  private readonly phonePattern = /^[0-9]{7,13}$/;
  private readonly heightPattern = /^\d{2,3}([.,]\d{1,2})?$/;
  private readonly weightPattern = /^\d{2,3}([.,]\d{1,2})?$/;
  studentForm = new FormGroup({
    id: new FormControl(''),
    status: new FormControl(''),
    name: new FormControl('', [Validators.required]),
    email: new FormControl('', [Validators.required, Validators.email, Validators.maxLength(150)]),
    goal_id: new FormControl('', [Validators.required]),
    password: new FormControl('', [Validators.required, Validators.minLength(6), Validators.maxLength(16)]),
    password_confirmation: new FormControl('', [Validators.required, Validators.minLength(6), Validators.maxLength(16)]),
    details: new FormGroup({
      ddi: new FormControl('', [Validators.required]),
      phone: new FormControl('', [Validators.required, Validators.pattern(this.phonePattern)]),
      birthdate: new FormControl('', [Validators.required]),
      gender: new FormControl('', [Validators.required]),
      height: new FormControl('', [Validators.required, Validators.pattern(this.heightPattern)]),
      weight: new FormControl('', [Validators.required, Validators.pattern(this.weightPattern)]),
    }),
  });


  constructor(
    private route: ActivatedRoute,
    public dialog: MatDialog,
    public auth: AuthService,
    public toastr: ToastrService,
    public api: ApiProvider,
    public goalProvider: GoalProvider,
    public studentProv: CustomerProvider,
    public userProv: UserProvider,
    public helpers: HelpersProvider,
    public i18n: I18nProvider,
  ) {
    const qs = this.helpers.getUrlParam();
    if (qs.l !== null) this.helpers.changeLang(qs.l);

    this.STRINGS = this.i18n.translate();
    this.PAGE = this.i18n.translate('CustomerWaitlineComponent');

    this.headers = {'Authorization': `Bearer ${localStorage.getItem('LoggedInUser')}`};
    // this.teacherCode = this.route.snapshot.params.code;

    this.route.queryParams.subscribe(
      (params: any) => {
        // Defaults to 0 if no query param provided.
        this.teacherCode = params['code'] || '';
      }
    );
    this.studentForm.setValidators(this.passwordsMatchValidator);

  }

  ngOnInit() {
    this.selectedLayoutTheme = normalizeLayoutTheme(localStorage.getItem(LAYOUT_THEME_STORAGE_KEY));
    this.modernLayoutTheme = isModernLayoutTheme(this.selectedLayoutTheme);
    this.codes = this.helpers.sortByProperty(codes, 'nome');
    this.ddiOptions = this.codes.map(code => {
      const countryName = this.helpers.returnTranslation(code, 'nome');
      const formattedCode = `+${Number(code.fone)}`;

      return {
        value: code.fone,
        label: countryName,
        triggerLabel: formattedCode,
        code: formattedCode,
        flagUrl: `assets/flags/${code.fone}.png`,
        search: `${countryName} ${code.fone} ${formattedCode} ${code.iso}`,
      };
    });
    this.studentForm.reset();
    this.showForm = true;
    this.studentSelected = false;
    this.studentId = 0;
    this.studentForm.patchValue({ status: 8, details : { ddi: '0055', gender: 'm'} });
    this.getTeacherGreeting();
  }

  ngOnDestroy() {
    this.setPrecadDatepickerOpen(false);
  }

  changeLayoutTheme(theme: string) {
    this.setPrecadDatepickerOpen(false);
    this.selectedLayoutTheme = normalizeLayoutTheme(theme);
    this.modernLayoutTheme = isModernLayoutTheme(this.selectedLayoutTheme);
    localStorage.setItem(LAYOUT_THEME_STORAGE_KEY, this.selectedLayoutTheme);
    applyLayoutTheme(this.selectedLayoutTheme);
  }

  setPrecadDatepickerOpen(open: boolean): void {
    const themeRoot = document.getElementById('main-body') || document.body;
    themeRoot.classList.toggle('modern-profile-datepicker-open', open && this.modernLayoutTheme);
  }

  getSelectedLayoutThemeLabel() {
    const selectedTheme = this.layoutThemes.find(theme => theme.value === this.selectedLayoutTheme);
    return selectedTheme ? selectedTheme.label : 'Classic Dark';
  }

  handleCaptcha(token: string) {
    this.captcha = token;
  }

  getTeacherGreeting() {
    this.loading = true;
    // busca os objetivos dos alunos
    this.goalProvider.indexOpen().then(
      (res: any) => {
        this.goals = res.goals;

        // busca o avatar e saudacao do professor
        this.userProv.getTeacherGreeting(this.teacherCode).then(
          (res: any) => {
            this.loading = false;
            this.teacher = res.teacher;
            this.configureGoalValidation();
          },
          (err: any) => {
            this.toastr.error(err, '', this.helpers.toastrCfgs);
            this.teacher = null;
            this.loading = false;
          }
        );

      },
      (err: any) => {
        console.log(err);
        this.toastr.error(err, '', this.helpers.toastrCfgs);
        this.loading = false;
    });
  }

  new() {
    this.studentForm.reset();
    this.showForm = true;
    this.studentSelected = false;
    this.studentId = 0;
    this.studentForm.patchValue({ status: 2, details : { ddi: '0055', gender: 'm'} });
  }


  save() {
    this.validateAllFormFields(this.studentForm);
    this.studentForm.updateValueAndValidity();

    if (this.studentForm.invalid) {
      this.toastr.error((this.PAGE.preencha_campos || 'Revise os campos obrigatórios e tente novamente.'), '', this.helpers.toastrCfgs);
      return false;
    }

    if (this.recaptchaEnabled && !this.captcha) {
      this.toastr.error((this.PAGE.captcha_obrigatorio || 'Confirme o reCAPTCHA para continuar.'), '', this.helpers.toastrCfgs);
      return false;
    }

    if (this.studentForm.value.password !== this.studentForm.value.password_confirmation) {
      this.toastr.error(this.STRINGS.RegistrationPage.senha_diferente, '', this.helpers.toastrCfgs);
      return false;
    }

    const dataString = JSON.stringify(this.studentForm.value);
    const data = JSON.parse(dataString);
    data.details.phone = (data.details.phone || '').toString().replace(/\D/g, '');
    data.details.height = (data.details.height || '').toString().replace(',', '.');
    data.details.weight = (data.details.weight || '').toString().replace(',', '.');
    data.details.birthdate = this.normalizeBirthdate(data.details.birthdate);
    data.p = this.teacherCode;
    data.token = this.captcha;

    if (!data.goal_id) data.goal_id = 1;

    this.loading = true;
    this.studentProv.createCustomer(data).then(
      (_user: any) => {
        this.loading = false;
        // this.toastr.success('Pedido registrado com sucesso!');
        this.done = true;
      },
      (err: any) => {
        this.loading = false;
        // console.log(err);
        
        const rawMessage = (err?.err?.message || err?.error?.message || err?.message || '').toString();
        const errMsg = rawMessage.replace(/^Error:\s*/, '');
        // console.log(errMsg);

        let msg = '';
        msg += '<h2>'+this.PAGE.atencao+'</h2>';
        msg += '<center>'+(this.STRINGS.algo_errado || 'Algo não funcionou bem. Tente novamente mais tarde.')+'</center>';

        if (errMsg === 'Já existe uma conta com esse email!') {
          msg = '<h2>'+this.PAGE.atencao+'</h2>';
          msg += '<center>'+this.PAGE.este_email+'</center>';
          msg += '<center>'+this.PAGE.favor_email+'</center>';
        }
        if (errMsg === 'Domínio de Email não permitido') {
          msg = '<h2>'+this.PAGE.atencao+'</h2>';
          msg += '<center>'+(this.PAGE.dominio_ruim || 'Domínio de Email não permitido!')+'</center>';
          msg += '<center>'+this.PAGE.favor_email+'</center>';
        }
        if (errMsg === 'Cadastros desabilitados temporariamente') {
          msg = '<h2>'+this.PAGE.atencao+'</h2>';
          msg += '<center>'+(this.PAGE.cadastro_fechado_1 || 'Cadastros desabilitados temporariamente')+'</center>';
          msg += '<center>'+(this.PAGE.cadastro_fechado_2 || 'Verifique com o seu personal')+'</center>';
        }

        const dialogRef = this.dialog.open(DialogLightComponent, { width: '30vw', data: { message: msg, bt_ok: 'Ok' } });
        dialogRef.afterClosed().subscribe(_result => {});  
      }
    );

  }

  getUserFormValidationMessage(el: any) {
    if (!el || !el.errors) return '';

    if (el.errors.required) {
      return this.STRINGS.campo_obrigatorio;
    }

    if (el.errors.email) {
      return (this.PAGE.email_invalido || 'Informe um email válido.');
    }

    if (el.errors.minlength) {
      return (this.PAGE.senha_menor || 'A senha precisa ter no mínimo 6 caracteres.');
    }

    if (el.errors.maxlength) {
      return (this.PAGE.campo_maximo || 'Você atingiu o limite máximo de caracteres.');
    }

    if (el.errors.incorrect || el.errors.pattern) {
      return this.STRINGS.campo_invalido;
    }

    return this.STRINGS.campo_invalido;
  }

  validateAllFormFields(formGroup: FormGroup) {         //{1}
    Object.keys(formGroup.controls).forEach(field => {  //{2}
      const control = formGroup.get(field);             //{3}
      if (control instanceof FormControl) {             //{4}
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {        //{5}
        this.validateAllFormFields(control);            //{6}
      }
    });
  }

  private configureGoalValidation(): void {
    const goalControl = this.studentForm.get('goal_id');
    if (!goalControl) return;

    if (this.teacher?.account_type === 'nutri') {
      goalControl.clearValidators();
      if (!goalControl.value) goalControl.setValue(1);
    } else {
      goalControl.setValidators([Validators.required]);
      if (!goalControl.value) goalControl.setValue('');
    }

    goalControl.updateValueAndValidity({ emitEvent: false });
  }

  private passwordsMatchValidator = (control: AbstractControl): ValidationErrors | null => {
    const password = control.get('password')?.value || '';
    const passwordConfirmation = control.get('password_confirmation')?.value || '';

    if (!password && !passwordConfirmation) {
      return null;
    }

    return password === passwordConfirmation ? null : { passwordMismatch: true };
  };

  private normalizeBirthdate(value: any): string | null {
    if (!value) return null;

    if (value instanceof Date && !isNaN(value.getTime())) {
      return value.toISOString().slice(0, 10);
    }

    const stringValue = value.toString().trim();
    if (!stringValue) return null;

    const isoMatch = stringValue.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (isoMatch) {
      return `${isoMatch[1]}-${isoMatch[2]}-${isoMatch[3]}`;
    }

    const parsedDate = new Date(stringValue);
    if (!isNaN(parsedDate.getTime())) {
      return parsedDate.toISOString().slice(0, 10);
    }

    return null;
  }

  toggleClass(item: any) {
    item.active = !item.active;
  }


  helpWaitline() {
    let msg = this.PAGE.saudacao_ajuda;

    const dialogRef = this.dialog.open(DialogLightComponent, { width: '360px', data: { message: msg } });
    dialogRef.afterClosed().subscribe(_result => {});
  }


}
